import { EnvironmentColor } from 'types';

const COOKIE_NAME = 'bgv';
const GREEN_COOKIE_VALUE = 'c2';
const BLUE_COOKIE_VALUE = 'c1';

export function getActiveColor(req): EnvironmentColor | undefined {
	const bgv = req?.cookies?.[COOKIE_NAME];
	if (bgv === GREEN_COOKIE_VALUE) {
		return EnvironmentColor.Green;
	}

	if (bgv === BLUE_COOKIE_VALUE) {
		return EnvironmentColor.Blue;
	}

	return undefined;
}

export function getGraphParameter(graphColor: EnvironmentColor): string {
	if (!graphColor) {
		return '';
	}

	return `?graph-app-version=${graphColor}`;
}